import { UserProfileAssessmentModel } from '@/domain/models/profile-assessment/user-profile-assessment-model'

export interface UserProfileAssessment {
  getLatest(): Promise<UserProfileAssessment.Model | null>
  create(): Promise<UserProfileAssessment.Model | null>
  sync(externalUniqueId: string): Promise<UserProfileAssessment.Model | null>
}

export namespace UserProfileAssessment {
  export type Model = UserProfileAssessmentModel
  export const KeyGet = 'user-profile-assessment-get'
  export const KeyCreate = 'user-profile-assessment-create'
  export const KeySync = 'user-profile-assessment-sync'
}
